<template>
  <!-- 退出确认弹窗 -->
  <transition name="fade" mode="out-in">
    <div class="popup exit-confirm-popup" v-show="visible">
      <div class="popup-mask" @click="closePopup"></div>
      <div class="popup-content">
        <div class="popup-content-close" @click="closePopup"></div>
        <!-- 按钮区域 -->
        <div class="exit-confirm-buttons">
          <div class="confirm-button" @click="confirmExit"></div>
          <div class="cancel-button" @click="closePopup"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

// 定义 emits
const emit = defineEmits(["update:visible", "confirm"]);

// 方法
const closePopup = () => {
  emit("update:visible", false);
};

// 确认退出
const confirmExit = () => {
  emit("confirm");
  emit("update:visible", false);
};
</script>
